import type { FaireProductEntity } from "../../entity_types/product";

export const p_rg3pguandd: FaireProductEntity = {
  token: "p_rg3pguandd",
  type: "product",
  name: "Rosemary Essential Oil | Aromatherapy Hair, Skin, & Nails",
  brandToken: "b_v59f599x2t",
  brandName: "Plant of Life",
  imageUrl:
    "https://cdn.faire.com/fastly/ee27752704e8951a66c4ce110c2b49ba8413574066908b6f158bf8ce4d6652c1.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7af7fb0d85b39d8bb7f03478991b3b512cf98c7da5d216e9efbc6015cae4c48d.jpeg",
    "https://cdn.faire.com/fastly/db41d2f92b2b75349f3fb9faa2761c0d114805aeaf520a58d02a5b26a7341c78.jpeg",
    "https://cdn.faire.com/fastly/5dda524d9590cc752755864642bcab4ebc53d1cc6d11652999274495f9062015.jpeg",
    "https://cdn.faire.com/fastly/eb54e17ce89cb213913d1a216cb6a036ed939f67d54551f8acc77f93658c0ccc.jpeg",
    "https://cdn.faire.com/fastly/f425c4727a937486314c32dd75f8975f2c1dcdc79af38a2e8ca39196ff95d2d4.jpeg",
    "https://cdn.faire.com/fastly/28c6a42e4b8e04c360e2c0eeb7284a119c94c60543abb4202f83a7590eca9915.jpeg",
    "https://cdn.faire.com/fastly/fe8021798e283c2b36778304073d972be2adaa4be9473eb1940ef2bc615ff416.jpeg",
  ],
  priceDollars: 8.3,
  description:
    "Embrace the Beauty and Elegance of Rosemary Essential Oil - Elevate Your Aromatherapy, Haircare, Skincare, and Nailcare Rituals!\n\nUnveil the captivating essence of Rosemary Essential Oil, a luxurious elixir that transcends the realms of relaxation, beauty, and wellness. With its myriad of benefits for hair, skin, and nails, this aromatic gem is a must-have addition to your daily self-care routine.\n\nBenefits:\n\nAromatherapy Serenity: Delight in the enchanting aroma of Rosemary Essential Oil as it envelops your senses in tranquility. Its invigorating fragrance promotes mental clarity, rejuvenates the mind, and creates a soothing ambiance in your space.\n\nLustrous Hair: Experience the magic of Rosemary Essential Oil as it revitalizes your hair. Its nourishing properties help stimulate hair follicles, promoting healthy growth and adding shine to your locks.",
  tags: [],
  msrpDollars: 16.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:44.631Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
